import { render, staticRenderFns } from "./createWarehouse.vue?vue&type=template&id=0bb7b138&scoped=true"
import script from "./createWarehouse.vue?vue&type=script&lang=js"
export * from "./createWarehouse.vue?vue&type=script&lang=js"
import style0 from "./createWarehouse.vue?vue&type=style&index=0&id=0bb7b138&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb7b138",
  null
  
)

export default component.exports